



































import {
  defineComponent,
  computed,
  ref,
  watch
} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import type { BundleItem, BundleItemOption } from '@wemade-vsf/magento-api';
import type { SelectedBundleProductOptions } from '@wemade-vsf/catalog/lib/runtime/product/helpers/bundleProduct';
import type { Product } from '@wemade-vsf/catalog/lib/runtime/product/types';
import {
  getName as getProductName
} from '@wemade-vsf/catalog/lib/runtime/product/getters/productGetters';
import { useCustomerPricing } from '@wemade-vsf/catalog/lib/runtime/product/composables/useCustomerPricing';
import { SfRadio, SfPrice, SfQuantitySelector } from '@storefront-ui/vue';

export default defineComponent({
  name: 'BundleRadioRenderer',
  props: {
    bundle: {
      type: Object as PropType<BundleItem>,
      required: true
    },
    selectedOptions: {
      type: Object as PropType<SelectedBundleProductOptions>,
      required: true
    }
  },
  components: {
    SfRadio,
    SfPrice,
    SfQuantitySelector
  },
  emits: ['update:selectedOptions'],
  setup (props, { emit }) {
    const { getPriceForProduct } = useCustomerPricing();
    const selected = ref<string>('');
    const qty = ref<number>(1);

    function isQtyChangeEnabledForOption(option: BundleItemOption|null) {
      if (!option?.product) {
        return false;
      }
      return option.can_change_quantity;
    }

    const canChangeQty = computed(() => {
      if (!selected.value) {
        return false;
      }
      const option = (props.bundle as BundleItem).options!.find((opt) => opt?.uid === selected.value);
      if (!option) {
        return false;
      }
      return isQtyChangeEnabledForOption(option);
    })

    function emitChange(option: BundleItemOption) {
      emit('update:selectedOptions', {
        uid: option.uid,
        quantity: isQtyChangeEnabledForOption(option) ? qty.value : 1,
        price: getPriceForProduct(option.product! as unknown as Product).final,
      })
    }

    function emitChangeQty() {
      if (!selected.value) {
        return;
      }
      const option = (props.bundle as BundleItem).options!.find((opt) => opt?.uid === selected.value);
      if (!option || !option.product) {
        return;
      }
      emitChange(option);
    }

    watch(() => props.selectedOptions, (value) => {
      selected.value = (value[(props.bundle as BundleItem).uid!] as any)?.uid ?? '';
    }, { immediate: true, deep: true })

    return {
      qty,
      selected,
      emitChange,
      emitQtyChange: emitChangeQty,
      getProductName,
      getProductPrice: getPriceForProduct,
      canChangeQty
    }
  }
});
